// app/components/ErrorBoundary.tsx
import { isRouteErrorResponse, useRouteError } from "@remix-run/react";

export default function ErrorBoundary() {
  const error = useRouteError();

  if (typeof window !== "undefined" && typeof gtag === "function") {
    gtag("event", "error_boundary", {
      event_category: "error_boundary",
      event_label: error.name
    });
  }

  if (isRouteErrorResponse(error)) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center text-center p-6 text-gray-700">
        <h1 className="text-4xl font-bold mb-4">🚧 Error {error.status}</h1>
        <p className="text-lg">{error.statusText}</p>
        {error.data?.message && (
          <pre className="mt-4 p-4 bg-gray-100 rounded-md border text-left text-sm text-red-700">
            {error.data.message}
          </pre>
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-center p-6">
      <h1 className="text-4xl font-bold mb-4">💥 Something went wrong</h1>
      <p className="text-lg text-gray-700">An unexpected error occurred. Please refresh the page!</p>

      {process.env.NODE_ENV === "development" && error instanceof Error && (
        <pre className="mt-4 p-4 bg-gray-100 rounded-md border text-left text-sm text-red-700 overflow-auto max-w-full">
          <strong>{error.name}:</strong> {error.message}
          {"\n"}
          {error.stack}
        </pre>
      )}
    </div>
  );
}
